import React from "react";
import { LootBoxService } from "../../services/lootBox/LootBoxService";
import { LootBox } from "../LootBox/LootBox";
import { Info } from "./Info";

const lootBoxService = new LootBoxService(
  process.env.REACT_APP_LOOT_BOX_HOST + ""
);
lootBoxService.init().catch((error) => {
  console.log("failed to init loot box service", error);
});

interface Props {
  isLootBoxVisible: boolean;
  hideLootBox: () => void;
}
const InfoContainer: React.FC<Props> = ({ isLootBoxVisible, hideLootBox }) => {
  return isLootBoxVisible ? (
    <LootBox
      lootBoxService={lootBoxService}
      hideLootBox={hideLootBox}
    />
  ) : (
    <Info />
  );
};

export default InfoContainer;
